module.exports = __webpack_public_path__ + "img/usa-cancer-male.4abc4dd0.png";